import { Link } from "react-router-dom"

export function BuddyTile({buddy}){
	console.log(buddy);
	return <div className="info-tile">
		<div className="image-section">
			<img src="https://avatar.iran.liara.run/public/43" alt="" />
		</div>
		<div className="primary-info-section">
			<b>{buddy.buddy_name}</b>
			<p>Permissions: {buddy.permissions}</p>
		</div>
		<div className="secondary-info-section">
			<span className={`status-card member-label ${buddy.status}`}> {buddy.status}</span>
			<p>Role: {buddy.role}</p>
		</div>
		<div className="action-section">
			<Link className="red-text" to={`/dashboard/buddies/u/${buddy.buddy_id}`}>Details </Link>
		</div>
	</div>
}